'use client';

import type {BundleHeaderProps as Props} from './typings';

import {StyledProductBundleHeader, StyledText} from './styles';

const BundleHeader = ({discountPercentage}: Props): JSX.Element => (
  <StyledProductBundleHeader>
    <h5 aria-label="Buy two artworks together">
      Buy these two artworks together and&nbsp;
      <StyledText $isBold $isRed>
        save {discountPercentage}
      </StyledText>
    </h5>
  </StyledProductBundleHeader>
);

export default BundleHeader;
